import { CONTACT_DETAILS_BLOCKS_FLAT_MAP } from "../constants";
import type { ContactDetailsBlockType } from "../types";

/**
 * Whether a string names a block the registry knows about, narrowing it to
 * {@link ContactDetailsBlockType}.
 *
 * Persisted `block.type` values come off the model as plain strings — a saved view can name a block
 * this build no longer ships — so anything reading them has to narrow before indexing the registry.
 */
export const isRegisteredBlockType = (blockType: string): blockType is ContactDetailsBlockType =>
  blockType in CONTACT_DETAILS_BLOCKS_FLAT_MAP;
